export type TemplateName = 'English' | 'Hebrew';

export const TEMPLATE_SPREADSHEET_IDS: Record<TemplateName, string> = {
  English: '1xu9jOkRFRxzmIj5HJWve7efWj2wMOpF61dpTczPL4VI',
  Hebrew: '1cSut0MmmKTrieD1RPAEYfQtsjuMChdyjk88ZTa6Yw18',
};

export const TEMPLATE_NAMES = Object.keys(TEMPLATE_SPREADSHEET_IDS) as TemplateName[];

export function getTemplateSpreadsheetId(name: TemplateName): string {
  return TEMPLATE_SPREADSHEET_IDS[name];
}
